export const generateStatusStyle = (statusArray, statusId):React.CSSProperties => {
  const status = statusArray.find((sts) => sts?.value === statusId);
  return {
      color: status?.color,
      backgroundColor: status?.color + "20",
  }
};
